export default __webpack_public_path__ + "static/media/page-feedback-bcg.76597815.png";